import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import VehicleHireForm, { VehicleHireFormModeEnum } from '../VehicleHireForm';
import { useParams } from "react-router-dom";
const VehicleHireEditPage = () => {
    const params = useParams();
    return (_jsx(VehicleHireForm, { mode: VehicleHireFormModeEnum.MODE_UPDATE, vehicleHireId: Number(params.vehicleHireId) }));
};
export default VehicleHireEditPage;
